import { InjectionToken } from '@angular/core'

export const WA_MUTATION_OBSERVER_INIT = new InjectionToken<MutationObserverInit>('[WA_MUTATION_OBSERVER_INIT]')
